import { render, staticRenderFns } from "./FatturaUscita.vue?vue&type=template&id=8c91ed36"
import script from "./FatturaUscita.vue?vue&type=script&lang=js"
export * from "./FatturaUscita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports